import type { HotelPolicy } from '@shared/types/hotel-content';

const BREAKFAST_TYPE = 'HOTEL_POLICY_TYPE_BREAKFAST';
const PETS_TYPE = 'HOTEL_POLICY_TYPE_PET';
const CHILDREN_TYPE = 'HOTEL_POLICY_TYPE_CHILDREN';

export const getBreakfastPolicy = (hotelPolicies?: HotelPolicy[]) =>
  hotelPolicies?.find(({ type }) => type === BREAKFAST_TYPE);

export const getPetsPolicy = (hotelPolicies?: HotelPolicy[]) =>
  hotelPolicies?.find(({ type }) => type === PETS_TYPE);

export const getChildrenPolicy = (hotelPolicies?: HotelPolicy[]) =>
  hotelPolicies?.find(({ type }) => type === CHILDREN_TYPE);
